class RestrictATC extends HTMLElement {
  constructor(){
    super();

    const script = this.querySelector('script');
    const data = script ? JSON.parse(script.innerText) : null;
    const stateSelected = document.documentElement.dataset.stateSelected;
    const addToCartBtn = this.querySelector('[data-js-product-add-to-cart]');
    const addToCartBtnText = this.querySelector('[data-js-product-add-to-cart-text]');

    const stickyATC = document.querySelector('.js-sticky-atc');

    if(stickyATC) {
      const stickyATCParent = stickyATC.closest('.pdp-sticky-atc');
      const stickyATCText = stickyATC.querySelector('.js-sticky-atc-text');
      stickyATCText.innerText = addToCartBtnText.innerText;
      const observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          stickyATCParent.classList.remove('hide');
        }
        else {
          stickyATCParent.classList.add('hide');
        }
      });
    
      observer.observe(addToCartBtn);

      $(document).on("click", '.js-sticky-atc', (e) => {
        addToCartBtn.click();
      })
    }

    if (!data || !data.enabled || !stateSelected) {
      return;
    }

    // console.log({ data });

    const productTags = data.product_tags.split(', ');
    const states = ['QLD', 'VIC', 'NSW', 'SA', 'WA', 'NT', 'ACT', 'TAS'];
    const hasStateTags = productTags.filter((tag) => states.includes(tag));

    // console.log({ hasStateTags, productTags, stateSelected });

    if (!hasStateTags.length) {
      console.log('Product available for purchase on all states...')
      return;
    }

    // console.log('Product not available in selected state', !hasStateTags.includes(stateSelected));

    // Product not available on selected state/location
    if (!hasStateTags.includes(stateSelected)) {

      const formatter = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' });
      const note = document.createElement('div');
      note.classList.add('alert', 'alert--restricted', 'alert--error');
      note.innerHTML = data.messaging ? data.messaging.replace('[state]', formatter.format(hasStateTags)) : 'This product is not available in your selected location.';
      this.append(note);

      if (addToCartBtn) {
        addToCartBtn.disabled = true;
      }

      if (addToCartBtnText) {
        addToCartBtnText.innerText = 'Not available'
        if(stickyATC) {
          const stickyATCText = stickyATC.querySelector('.js-sticky-atc-text');
          stickyATCText.innerText = 'Not available';
          stickyATC.disabled = true;
        }
      }
    }
  }
}
if (!customElements.get('restrict-atc-by-location')){
  customElements.define('restrict-atc-by-location', RestrictATC);
}